import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import TopNavComponent from "../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import PaginationComponent from "../../../components/_utils/PaginationComponent/index.jsx";
import InternalAccDetailsPopUp from "../../../components/Accounts/InternalAccDetailPopup";
import InternalTxnDetailPagePopup from "../../../components/InternalTransactionMain/InternalTxnDetailPopup";
import InternalTxnMultiApproval from "../../../components/InternalTransactionMain/InternalTxnMultiApproval";
import Loader from "../../../components/Loader/Index.jsx";
import { internalSingleApproval } from "../../../redux/features/internalTransaction/internalTransactionSingleApproval.js";

import {
  disableSwitcher,
  enableSwitcher,
} from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import { getRefreshTokenNew } from "../../../redux/features/refreshToken/refreshToken.js";
import { GlobalConfiguration } from "../../../utils/configurationProvider.js";
import "./index.css";

const InternalTransactionMultiApproval = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [label, setlabel] = useState("Select category");
  const [filterOpen, setFilterOpen] = useState(false);
  const [allAccounts, setAllAccounts] = useState([]);
  const [page, setPage] = useState(1);
  const [selectedPageValue, setSelectedPageValue] = useState(50);
  const [impureData, setImpureData] = useState({});
  const [selectAllCard, setselectAllCard] = useState(false);
  const [allBeneTxnAccountsLoading, setAllBeneTxnAccountsLoading] =
    useState(false);
  const [pageSize, setPageSize] = useState(50);
  const [approvedAccounts, setApprovedAccounts] = useState([]);
  const [selectedTransactions, setSelectedTransactions] = useState([]);
  const [selectedSendTransactions, setSelectedSendTransactions] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [txnId, setTxnId] = useState(null);
  const [showMultiTxnDetailPop, setShowMultiTxnDetailPop] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [internalAccountid, SetInternalAccountid] = useState("");
  const [internalAccDetailOpen, setInternalAccDetailOpen] = useState(false);
  const [LabelSearchText, setLabelSearchText] = useState([]);
  const [labels, setLabels] = useState([]);
  const [selectedLabels, setSelectedLabels] = useState([]);
  const filterRef = useRef(null);
  const filterRef1 = useRef(null);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchUserTextDebounce, setsearchUserTextDebounce] = useState("");
  const [inputData, setInputData] = useState([]);
  const [active, setActive] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const { internalTxnSingleApprovalData } = useSelector(
    (state) => state.internalTxnSingleApproval,
  );

  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const shouldShowPagination =
    !allBeneTxnAccountsLoading &&
    impureData &&
    impureData.total_count > GlobalConfiguration?.lengthCheckZero &&
    allAccounts.length > GlobalConfiguration?.lengthCheckZero;

  const onMount = () => {
    setAllBeneTxnAccountsLoading(true);
    dispatch(
      internalSingleApproval({
        page_no: page,
        page_size: pageSize,
        search: searchText || undefined,
        labels: LabelSearchText,
      }),
    )
      .then((response) => {
        setImpureData(response?.payload);
        const newData =
          response?.payload?.transactions?.map((account) => ({
            ...account,
            loading: false,
            error: "false",
            message: "",
          })) || [];

        setAllAccounts(newData);

        setAllBeneTxnAccountsLoading(false);

        const approved = newData.filter(
          (account) => account.internal_account_approval_status === "approved",
        );
        setApprovedAccounts((prevApproved) => [...prevApproved, ...approved]);
      })
      .catch(() => {
        setAllBeneTxnAccountsLoading(false);
      });
  };
  useEffect(() => {
    dispatch(enableSwitcher());

    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    onMount();
  }, [page, pageSize, LabelSearchText, searchText, markerData]);

  const handlePageSelect = (value) => {
    setSelectedPageValue(value);
    setPageSize(value);
    setPage(1);
  };

  useEffect(() => {
    const handlefilter = (e) => {
      if (filterRef.current && filterRef.current.contains(e.target)) {
        setFilterOpen(false);
      } else if (filterRef1.current && filterRef1.current.contains(e.target)) {
        setFilterOpen(false);
      }
    };
    document.addEventListener("click", handlefilter);
  }, [filterOpen]);

  const handleSelectAll = (tt) => {
    const alreadySelectedCount = selectedTransactions?.length;
    const remainingSelections = 20 - alreadySelectedCount;
    if (tt) {
      let x = [];
      approvedAccounts.map((itm) => {
        if (selectedTransactions.includes(itm.txn_id)) {
          x.push(itm.txn_id);
        }
      });
      let y = selectedTransactions.filter((it) => !x.includes(it));
      let z = selectedSendTransactions.filter((itm) => !x.includes(itm.txn_id));
      setSelectedTransactions(y);
      setSelectedSendTransactions(z);
      let amt = z.reduce(
        (sum, account) => sum + Number(account.amount),
        GlobalConfiguration?.lengthCheckZero,
      );
      setTotalAmount(amt);
    } else if (
      label === "Select category" &&
      remainingSelections === GlobalConfiguration?.lengthCheckZero
    ) {
      setSelectedTransactions([]);
      setSelectedSendTransactions([]);
      setTotalAmount(0);
    } else {
      const deselectCardHandle = () => {
        let x = [];
        approvedAccounts.map((itm) => {
          if (selectedTransactions.includes(itm.txn_id)) {
            x.push(itm.txn_id);
          }
        });
        let y = selectedTransactions.filter((it) => !x.includes(it));
        let z = selectedSendTransactions.filter(
          (itm) => !x.includes(itm.txn_id),
        );
        setSelectedTransactions(y);
        setSelectedSendTransactions(z);
        let amt = z.reduce(
          (sum, account) => sum + Number(account.amount),
          GlobalConfiguration?.lengthCheckZero,
        );
        setTotalAmount(amt);

        console.log(amt);
      };
      if (
        remainingSelections > GlobalConfiguration?.lengthCheckZero &&
        alreadySelectedCount > GlobalConfiguration?.lengthCheckZero &&
        alreadySelectedCount ===
          allAccounts.filter(
            (account) =>
              account.internal_account_approval_status === "approved",
          )?.length
      ) {
        deselectCardHandle();
      } else if (remainingSelections > GlobalConfiguration?.lengthCheckZero) {
        const newSelections = allAccounts
          .filter(
            (account) =>
              account.internal_account_approval_status === "approved" &&
              !selectedTransactions.includes(account.txn_id),
          )
          .slice(0, remainingSelections)
          .map((account) => account.txn_id);

        const newSelectionsSend = allAccounts
          .filter(
            (account) =>
              account.internal_account_approval_status === "approved" &&
              !selectedTransactions.includes(account.txn_id),
          )
          .slice(0, remainingSelections)
          .map((account) => account);

        setSelectedTransactions((prevSelected) => [
          ...prevSelected,
          ...newSelections,
        ]);

        setSelectedSendTransactions((prevSelected) => [
          ...prevSelected,
          ...newSelectionsSend,
        ]);

        const newAmounts = allAccounts
          .filter((account) => newSelections.includes(account.txn_id))
          .reduce(
            (sum, account) => sum + Number(account.amount),
            GlobalConfiguration?.lengthCheckZero,
          );

        setTotalAmount((prevAmount) => prevAmount + newAmounts);
      } else {
        deselectCardHandle();
      }
    }
  };

  useEffect(() => {
    let availableLabels = sessionStorage?.getItem("AvailableLabelsInternalTxn");
    const parsedLabels = JSON.parse(availableLabels);
    setLabels(parsedLabels);
  }, []);

  const fetchFilterData = async () => {
    let data = [];
    setLoadingData(true);
    switch (active) {
      case "Labels":
        data = labels
          ?.filter((itm) => {
            if (itm.includes(searchUserTextDebounce)) return itm;
          })
          ?.map((val) => {
            return { id: val, Label: val };
          });
        setInputData(data);
        setLoadingData(false);
        break;

      default:
        setLoadingData(false);
        break;
    }
  };

  useEffect(() => {
    if (active?.length) {
      fetchFilterData();
    }
  }, [active]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter" && filterOpen) {
        handleFilterCategory();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedLabels, filterOpen]);

  const handleFilterCategory = () => {
    setLabelSearchText(selectedLabels);
    setPage(1);
    setFilterOpen(false);
  };

  const handleClearCategory = () => {
    setSelectedLabels([]);
    setLabelSearchText([]);
    setPage(1);
  };

  const openMultiTxnDetailModal = () => {
    setShowMultiTxnDetailPop(true);
  };

  const closeInternalTxnDetailModal = () => {
    setShowMultiTxnDetailPop(false);
  };

  const closeBeneAccountDetailModal = () => {
    setInternalAccDetailOpen(false);
  };

  return (
    <>
      {showMultiTxnDetailPop ? (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <InternalTxnDetailPagePopup
            closeInternalTxnDetailModal={closeInternalTxnDetailModal}
            internal_txn_id={txnId}
            type={"internal_txn_detail_modal"}
            setShowInternalTxnDetailPop={setShowMultiTxnDetailPop}
            error_msg={errorMessage}
            setErrorMessage={setErrorMessage}
          />
        </div>
      ) : null}

      {internalAccDetailOpen ? (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <InternalAccDetailsPopUp
            closeBeneAccountDetailModal={closeBeneAccountDetailModal}
            bene_account_id={internalAccountid}
            type={"bene_account_detail_modal"}
          />
        </div>
      ) : null}
      <div className="bg-primary-bg flex flex-col h-screen overflow-hidden relative pb-pagination-height">
        <div className="w-width-full h-navbar-breadcrumb-height Qmd:block hidden bg-primary-nav flex-shrink-0"></div>

        <TopNavComponent
          handleBack={() => navigate(-1)}
          topNavHeader={totalAmount}
          ispagination={shouldShowPagination}
          isFormattingNotRequired={false}
          prevBalance={0}
          ownerAccBalanceLoading={false}
          BalanceStateRequired={true}
          AllPageRefresh={false}
          topNavSubText="Total amount"
          isSelectionView={true}
          selectionText={`Transactions selected : ${selectedTransactions.length}`}
          selectionBtnProps={
            !shouldShowPagination
              ? undefined
              : {
                  btnText: "Select up to 20",
                  btnType: "button",
                  enabledBgColor:
                    selectedTransactions?.length <
                      GlobalConfiguration?.categorymaxLength &&
                    approvedAccounts.length !==
                      GlobalConfiguration?.lengthCheckZero &&
                    approvedAccounts.every((itm) =>
                      selectedTransactions.includes(itm.txn_id),
                    )
                      ? "var(--positive-bg)"
                      : selectedTransactions?.length ===
                          GlobalConfiguration?.categorymaxLength
                        ? "var(--positive-bg)"
                        : "var(--primary-nav-act)",
                  hoverOption:
                    selectedTransactions?.length <
                      GlobalConfiguration?.categorymaxLength &&
                    approvedAccounts.length !==
                      GlobalConfiguration?.lengthCheckZero &&
                    approvedAccounts.every((itm) =>
                      selectedTransactions.includes(itm.txn_id),
                    )
                      ? "black"
                      : selectedTransactions?.length ===
                          GlobalConfiguration?.categorymaxLength
                        ? "black"
                        : "white",
                  enabledTextColor: "var(--text-primary)",
                  icon:
                    selectedTransactions?.length <
                      GlobalConfiguration?.categorymaxLength &&
                    approvedAccounts.length !==
                      GlobalConfiguration?.lengthCheckZero &&
                    approvedAccounts.every((itm) =>
                      selectedTransactions.includes(itm.txn_id),
                    )
                      ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                      : selectedTransactions?.length ===
                          GlobalConfiguration?.categorymaxLength
                        ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                        : "https://q2pay.in/new_assets/common/approval/select_all_with_white_outlined_circle.svg",
                  handleFunction: () => {
                    setselectAllCard(
                      approvedAccounts.every((itm) =>
                        selectedTransactions.includes(itm.txn_id),
                      )
                        ? true
                        : selectAllCard
                          ? false
                          : true,
                    );
                    handleSelectAll(
                      approvedAccounts.every((itm) =>
                        selectedTransactions.includes(itm.txn_id),
                      ),
                    );
                  },
                }
          }
          topNavCtaBtn2Props={{
            inActiveVariantNeeded: true,
            btnText: "Next",
            btnType: "button",
            enabledBgColor: "var(--text-primary)",
            enabledTextColor: "var(--primary-bg)",
            isDisabled: !selectedTransactions?.length,
            disabledBgColor: "var(--text-disabled)",
            disabledTextColor: "var(--text-primary)",
            handleFunction: () => {
              if (
                selectedTransactions?.length >=
                GlobalConfiguration?.lengthCheckOne
              ) {
                const selectedData = {
                  selectedSendTransactions,
                  selectedTransactions,
                  timestamp: Date.now(),
                };
                sessionStorage.setItem(
                  "selectedData",
                  JSON.stringify(selectedData),
                );

                navigate(
                  "/internal_transaction_dashboard/internal_transaction_multi_approval/multi_approval",
                );
              }
            },
          }}
          isToggleNeeded={true}
          toggleProps={{
            state: false,
            title: "Single Approval",
            handleClick: () =>
              navigate(
                "/internal_transaction_dashboard/internal_transaction_single_approval",
              ),
          }}
          filteredSearchProps={{
            setShowInnerSearchBar: setShowInnerSearchBar,
            showSearchBar: showSearchBar,
            isSearchDisabled: allBeneTxnAccountsLoading,
            onSearchInput: (val) => {
              setsearchUserTextDebounce(val);
            },
            searchText: searchUserTextDebounce,
            searchPlaceholder: "Search internal transaction",
            filterPlaceholder: "Search internal transaction",
            filterItems: [
              {
                name: "Labels",
                short_name: "Lab",
                isMulti: true,
                value: LabelSearchText,
                setValue: (val) => {
                  setPage(1);
                  setLabelSearchText(val);
                },
                isDropdown: true,
              },
            ],
            isSearchClearAllDisabled: !LabelSearchText?.length,

            inputData: inputData,
            active: active,
            setActive: setActive,
            loading: loadingData,
            setLoading: setLoadingData,
            isShowFilter: false,
            isShowSortBy: false,
          }}
        />
        <div className="flex-1 overflow-y-auto overflow-x-hidden w-width-full flex justify-center relative Qsmd:pb-padding-base pb-[var(--topnavbar-min-height)]">
          {showInnerSearchBar && (
            <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
          )}
          <div
            ref={filterRef}
            className="w-width-full overflow-y-auto"
            style={{
              overflow: filterOpen || showInnerSearchBar ? "hidden" : "auto",
              scrollPadding: "var(--padding-md)",
            }}
          >
            {allBeneTxnAccountsLoading ? (
              <div className="loader-container m-auto justify-center items-center flex h-height-full">
                <Loader />
              </div>
            ) : internalTxnSingleApprovalData === undefined ||
              !allAccounts?.length ? (
              <div className={`int-txn-mutli-no-account-found`}>
                <div className="flex justify-center items-center">
                  <img
                    src={
                      LabelSearchText?.length && !allAccounts?.length
                        ? "https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                        : "https://q2pay.in/new_assets/graphics/no_data/no_pending_transaction.svg"
                    }
                    // className="px-padding-sm w-graphic-width-md h-graphic-square-height-md int_txn_img"
                    alt="No data found"
                  />
                </div>
                <div className="int-txn-mutli-left-text-content-no-account">
                  <>
                    {LabelSearchText?.length &&
                    (!allAccounts?.length ||
                      allAccounts?.length === undefined) ? (
                      <>
                        <p className="text-font-md text-text-primary text-center">
                          No data found.
                        </p>
                        <div className="mt-margin-sm">
                          <PrimaryButton
                            btnText="Clear parameters"
                            handleFunction={() => {
                              setLabelSearchText("");
                              setSelectedLabels([]);
                            }}
                            enabledBgColor="var(--primary-act)"
                            enabledTextColor="var(--text-primary)"
                            hoverOption="white"
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        <p className="text-font-md text-text-primary text-center">
                          There are no more transactions that require <br />
                          your approval.
                        </p>
                        <div className="mt-margin-sm">
                          <PrimaryButton
                            btnText="Internal transaction dashboard"
                            handleFunction={() => {
                              navigate("/internal_transaction_dashboard");
                            }}
                            enabledBgColor="var(--primary-act)"
                            enabledTextColor="var(--text-primary)"
                            hoverOption="white"
                          />
                        </div>
                      </>
                    )}
                  </>
                </div>
              </div>
            ) : (
              <>
                {allAccounts?.length ? (
                  <div
                    className={`flex flex-col flex-1 items-center justify-center mx-auto ${
                      showInnerSearchBar ? "pointer-events-none" : ""
                    }`}
                    style={{
                      scrollPaddingTop: "var(--padding-md)",
                      scrollPaddingBottom: "var(--padding-md)",
                    }}
                  >
                    <InternalTxnMultiApproval
                      filterRef={filterRef}
                      filterOpen={filterOpen}
                      setAllAccounts={setAllAccounts}
                      data={allAccounts}
                      selectedTransactions={selectedTransactions}
                      setSelectedTransactions={setSelectedTransactions}
                      totalAmount={totalAmount}
                      setselectAllCard={setselectAllCard}
                      setTotalAmount={setTotalAmount}
                      selectedSendTransactions={selectedSendTransactions}
                      setSelectedSendTransactions={setSelectedSendTransactions}
                      txnId={txnId}
                      setTxnId={setTxnId}
                      openMultiTxnDetailModal={openMultiTxnDetailModal}
                      SetInternalAccountid={SetInternalAccountid}
                      internalAccDetailOpen={internalAccDetailOpen}
                      setInternalAccDetailOpen={setInternalAccDetailOpen}
                    />
                  </div>
                ) : null}
              </>
            )}
          </div>
        </div>
        {shouldShowPagination && (
          <div className="w-full z-z-index-fixed-ui relative">
            {showInnerSearchBar && (
              <div className="absolute inset-top-base bg-PopUp-BackDrop opacity-dark-opacity z-z-index-header pointer-events-none"></div>
            )}
            <PaginationComponent
              data={impureData}
              currentPage={page}
              dropdownOptions={[50, 100]}
              pageSize={pageSize}
              selectedValue={selectedPageValue}
              handleSelect={handlePageSelect}
              handlePagination={setPage}
              setIsOpen={setIsOpen}
            />
          </div>
        )}
      </div>
    </>
  );
};
export default InternalTransactionMultiApproval;
